var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenMediaFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "highlight_off-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13911",
    "data-name": "Path 13911",
    d: "M0,0H18V18H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "file_open_FILL0_wght400_GRAD0_opsz24",
    d: "M161.767-862.332a1.7,1.7,0,0,1-1.248-.519A1.7,1.7,0,0,1,160-864.1v-14.135a1.7,1.7,0,0,1,.519-1.248,1.7,1.7,0,0,1,1.248-.519h7.067l5.3,5.3v5.3h-1.767v-4.417h-4.417v-4.417h-6.184V-864.1h7.951v1.767Zm14.091.331-2.606-2.606v1.966h-1.767v-4.991h4.991v1.767h-1.988l2.606,2.606Zm-14.091-2.1v0Z",
    transform: "translate(-159.5 880)",
    fill: "#185edf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenMediaFile);
export default __webpack_public_path__ + "static/media/open_media_file.d870363e3e217f00cd65603e8357ee3d.svg";
export { ForwardRef as ReactComponent };